module.exports = __webpack_public_path__ + "img/hioV2.46f0ca57.svg";